import eliasPic from "@/public/images/artists/elias.png";
import { Artist } from "@/types/types";

export const elias = {
  id: "165",
  name: "Elias",
  image: eliasPic,
  description: `Elias's voice is bright and sharp, effortlessly transitioning from a resonant chest tone to a delicate falsetto. His vocal agility adds energy and finesse, especially through his precise runs and riffs.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Felias-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["RnB", "Dance", "Pop"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 72,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
